import { render, staticRenderFns } from "./AddnewItemsTax.vue?vue&type=template&id=cc9445ce&scoped=true&"
import script from "./AddnewItemsTax.vue?vue&type=script&lang=js&"
export * from "./AddnewItemsTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9445ce",
  null
  
)

export default component.exports